import {
  Moon,
  Filter,
  Menu,
  Search,
  Plus,
  Sun,
  Bell,
  Settings,
  ChevronDown,
} from "lucide-react";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserStore } from "../../store/useUserStore";

function TopBar({ onToggleSideBar }) {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  const location = useLocation(); // 👈 get current route

  // const { username } = useParams();

  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme(theme === "light" ? "dark" : "light");

  const navigate = useNavigate();
  const username = location.state?.username;

  // ✅ Map your routes to readable page titles
  const pageTitles = {
    "/": "Dashboard",
    "/dashboard": "Dashboard",
    "/account": "Account Settings",
    "/apps": "Applications",
    "/teams": "Teams",
    "/messages": "Messages",
    "/products": "Products",
    "/analytics": "Analytics",
    "/settings": "Settings",
    "/payments": "Payments",
    "/system/settings": "System Config",
    
    //payout--------------------------------
    "/payout/gateways": "Payment Gateways",
    "/payout/giftcodes": "Gift Codes",
    "/payout/giftcodes/:id": "Gift Cards",
    "/payout/analytics": "Payout Analytics",
    "/payout/configs": "Payout Configuration",

    "/utm": "UTM Reports",
    "/socials": "Social Handles",
    "/ads_revenue":"Ads Analytics",
    "/influencer":"Influencer",
    "/influencer/info":"Influencer Details",
    "/sponsor_apps": "Sponsor Apps",
    "/media/images": "Image Gallery",
    //reviews----------------------------
    "/apps/:id/reviews": "App Reviews",
    //app Analytics----------------------
    "/apps/:id/analytics": "App Analytics",
    //transactions------------------------
    "/apps/:id/transactions": "Transactions",
    "/apps/:id/transactions/:user_id": `${username}'s Transactions`,

    //app website--------------------
    "/apps/:id/website/privacy": "Privacy Policy",
    "/apps/:id/website/landing": "Landing Page",
    "/apps/:id/website/deeplink": "Deeplink Configuration",
    "/apps/:id/website/setting": "Settings",

    //app settings------------------
    "/apps/:id/settings/redirect": "Redirect Links",
    "/apps/:id/settings/withdrawal": "Withdrawal Configuration",
    "/apps/:id/settings/bonus": "Bonus",
    "/apps/:id/settings/payout": "Payout",
    "/apps/:id/settings/configs": "App Configurations",
    "/apps/:id/settings/socials": "Social Links Config",
    "/apps/:id/settings/sponsor_apps": "Sponsor App Config",

    //games manage
    "/games": "Manage Games",


    // app rule-------------------
    "/apps/:id/rule": "Rule",
    // app note-------------------
    "/apps/:id/note": "Notes",
  };
  const pageSubtitles = {
    "/": " ",
    "/dashboard": " ",
    "/account": "Manage your profile and security settings ",
    "/apps": "Manage your applications and their configurations",
    "/teams": "Manage Teams",
    "/analytics": "Analytics",
    "/settings": "Settings",
    "/payments": "Payments",
    "/media/images": "Upload and manage images for your website",

    "/payout/gateways": "Manage and configure payment gateway services",
    "/payout/giftcodes": "Manage and track your giftcode inventory",
    "/payout/giftcodes/:id": "Manage and track your giftcards ",
    "/payout/analytics": "Track payment distributions across apps and gateways",
    "/payout/configs": "Manage application settings and variables",
    "/utm": "Track performance metrics across all UTM campaigns",
    "/socials": "Manage your social media links",
    "/sponsor_apps": "Manage your sponsor apps links",

    "/apps/:id/website/privacy":
      "Configure your app privacy policy with dynamic values. Changes appear instantly in the preview.",
    "/apps/:id/website/landing":
      "Upload and preview your app landing page HTML file",
    "/apps/:id/website/deeplink":
      "Upload your deeplink JSON configuration file to set up deep linking for your app",
    "/apps/:id/website/setting":
      "Configure domain and SEO metadata for your app's landing page",

    // app settings------------------------
    "/apps/:id/settings/redirect":
      "Manage and track redirect links across different platforms",
    "/apps/:id/settings/withdrawal":
      "Manage payout settings and transaction thresholds",
    "/apps/:id/settings/socials": "Manage social links for active and inactive",

    "/apps/:id/settings/sponsor_apps":
      "Manage Sponsor Apps for active and inactive",

    //app rule-------------------
    "/apps/:id/rule": "Manage referral rules and bonus settings",
    //app notes-------------------
    "/apps/:id/note": "Manage your notes and important information",
  };

  // ✅ Automatically detect title based on path (support dynamic segments like :id)
  const currentPath = location.pathname.toLowerCase();

  const findMatchingKey = (path, map) => {
    // exact match first
    if (map[path]) return path;
    // try pattern matches where keys use :param
    for (const key of Object.keys(map)) {
      const pattern = "^" + key.replace(/:[^/]+/g, "[^/]+") + "$";
      const re = new RegExp(pattern);
      if (re.test(path)) return key;
    }
    return null;
  };

  const matchKey =
    findMatchingKey(currentPath, pageTitles) ||
    findMatchingKey(currentPath, pageSubtitles);
  const pageTitle = matchKey
    ? pageTitles[matchKey] || "Dashboard"
    : pageTitles["/dashboard"];
  const pageSubTitle = matchKey ? pageSubtitles[matchKey] || "" : "";

  //store items
  const avatar = useUserStore((state) => state.avatar);
  const name = useUserStore((state) => state.name);
  const role = useUserStore((state) => state.role);

  return (
    <div
      className="bg-white-80  dark:bg-slate-900/80 backdrop-blur-xl border-b
        border-slate-200/50 dark:border-slate-700/50 px-6 py-4"
    >
      <div className="flex items-center justify-between ">
        {/* left section */}
        <div className="flex items-center space-x-4 ">
          <button
            className="p-2 rounded-lg text-slate-600 dark:text-slate-300 hover:bg-slate-100
           dark:hover:bg-slate-800 transition-colors"
            onClick={onToggleSideBar}
          >
            <Menu className="w-5 h-5" />
          </button>
          <div className="hidden md:block">
            <h1 className="text-xl font-medium text-slate-800 dark:text-slate-200">
              {pageTitle}
            </h1>
            <p className="text-slate-800 dark:text-slate-400">{pageSubTitle}</p>
          </div>
        </div>
        {/* Center */}
        {/* <div className="flex-1 max-w-md mx-8">
          <div className="relative ">
            <Search className="w-4 h-4 absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              name=""
              placeholder="Search Anything"
              id=""
              className="w-full pl-10 pr-4 py-2.5 bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all"
            />
            <button className="absolute right-2 top-1/2  transform -translate-y-1/2 p-1.5 text-slate-400 hover:text-slate-600 dark:hover:text-slate-300">
              <Filter />
            </button>
          </div>
        </div> */}

        {/* Right */}
        <div className="flex items-center space-x-3">
          {/* Quick Action */}
          {/* <button
            className="hidden lg:flex items-center space-x-2 py-2 px-4
          bg-linear-to-r from-blue-500 to-purple-600 text-white rounded-xl hover:shadow transition-all"
          >
            <Plus className="w-4 h-4" />
            <span className="text-sm font-medium">New</span>
          </button> */}
          {/* toggle */}
          <button
            className="p-2.5 rounded-xl text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
            onClick={toggleTheme}
          >
            {theme === "light" ? (
              <Moon className="w-5 h-5" />
            ) : (
              <Sun className="w-5 h-5" />
            )}
          </button>
          {/* Notifications */}
          <button
            className="relative p-2.5 rounded-xl text-slate-600 dark:text-slate-300
          hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors "
          >
            <Bell className="h-5 w-5" />
            <span className="absolute -top-1 w-5 h-5 bg-red-500 text-white  text-xs rounded-full flex items-center justify-center"></span>
          </button>
          {/* Settings */}
          <button
            className="p-2.5 rounded-xl text-slate-600 dark:text-slate-300 hover:bg-slate-100  dark:hover:bg-slate-800 transition-colors"
            onClick={() => navigate("/system/settings")}
          >
            <Settings className="w-5 h-5" />
          </button>
          {/* User Profile */}
          <div
            onClick={() => {
              navigate("/account");
            }}
            className=" cursor-pointer flex items-center space-x-3 pl-3 border-l border-slate-200 dark:border-slate-700"
          >
            <img
              src={avatar}
              alt="User Image"
              className="w-8 h-8 rounded-full ring-2 ring-blue-500"
            />
            <div className="hidden md:block ">
              <p className="text-sm font-medium text-slate-500 dark:text-slate-400">
                {name}
              </p>
              <p className="text-xs text-slate-500 dark:text-slate-400">
                {role}
              </p>
            </div>
            {/* <ChevronDown className="w-4 h-4 text-slate-400" /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopBar;
